import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConnectorTag } from '@bciti/types';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {
    @Input() toolbarTitle: string;

    @Input() toolbarButtonText: string;

    @Output('onAction') actionOutput = new EventEmitter<any>();

    loading = false;

    ngOnInit(): void {}

    onAction(event): void {
        this.actionOutput.emit(event);
    }

    get title(): string {
        return this.toolbarTitle;
    }

    get buttonText(): string {
        return this.toolbarButtonText;
    }
}
